/**
 * This module defines all the exports for the `@qerent/lib` package.
 * 
 * BE VERY CAREFUL ABOUT REMOVING/RENAMING ANY EXPORTS HERE!  This will lead to breaking changes in tenant plugins.
 * 
 * When the package is built, the exports are bundled into a single module, which is published as `@qerent/lib`.
 * That module is then imported by third-party plugin developers, who can use all the components/actions/utilities exposed.
 * During module resolution (at runtime), the import map rewrites all relative imports for `@qerent/lib` back to this module.
 * This allows us to create an external package without having to segregate the web app into multiple packages.
 */

// Base styles...
import "./index.scss";

// Public types not directly exported...
export type {
    QerentComponent,
    ComponentDocumentation,
    AttributeDocumentation,
} from "./shared/components/DocumentedComponent";


// Namespace all base components...
import * as BaseComponentsModule from "./shared/components";
/**
 * The base UI components without any of the canvas data-binding features.
 * Used primarily when access is required to more low-level functionality or when custom data persistence logic is desired.
 */
export const BaseComponents = BaseComponentsModule;

// Hoist base components without a "viewer" counterpart to top-level entities...
export {
    SuccessAlert,
    ErrorAlert,
    WarningAlert,
    InfoAlert,
    DetailedErrorAlert,
    Avatar,
    Badge,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    ConfirmationDialog,
    InlineInfoTooltip,
    NoData,
    NoSearchResults,
    NothingYet,
    Popper,
    SearchTermHighlight,
} from "./shared/components/CanvasComponents";

// Export all our canvas components as top-level entities...
export * from "./viewer/components";

// Redux hooks...
export { useAppSelector } from "./store";
export { useAppActions } from "./shared/hooks";

// Testing utilities...
export {
    QerentAppStub,
} from "../test";